import { useDispatch, useSelector } from "react-redux";
import { printDeliveryThunk } from "../thunks/printDeliveryThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { DeliveryData } from "../types";
import { setPrintDeliveryFetchState } from "../deliveryDataSlice";

export const useDeliveryPrinter = (payment?: DeliveryData) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.clearing.deliveries.printReportFetchState
	);
	const dispatch = useDispatch();

	const download = React.useCallback(() => {
			dispatch(printDeliveryThunk(payment));
	}, [dispatch,payment ]);

	const dispatchSetFetch = React.useCallback(() => {                   //  Ovo da prvo izađe customDialog box
		dispatch(setPrintDeliveryFetchState({ type: "started" }))
	},	[dispatch] );
	
	return [download, fetchState, dispatchSetFetch] as [typeof download, typeof fetchState, typeof dispatchSetFetch];
};
